import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'

interface Props {
  unit: string
  year: number
  month: number
  onChange: (year: number, mont: number) => void
}

function toMonthStr(y: number, m: number) {
  return `${y}/${m}`
}

function DateRangePicker({ unit, year, month, onChange }: Props) {
  if (month > 12 || month < 1) throw Error('illegal month')
  const [startYear, startMonth] = month === 12 ? [year, 1] : [year - 1, month + 1]
  const lastDay = new Date(year, month, 0).getDate() // m: 0 indexed

  const RangeText = () =>
    unit === 'day' ? (
      <Typography variant="body2">
        {`${toMonthStr(year, month)}/1 - ${toMonthStr(year, month)}/${lastDay}`}
      </Typography>
    ) : (
      <Typography variant="body2">
        {`${toMonthStr(startYear, startMonth)} - ${toMonthStr(year, month)}`}
      </Typography>
    )

  const handlePrevClick = () => {
    const [newYear, newMonth] = month === 1 ? [year - 1, 12] : [year, month - 1]
    onChange(newYear, newMonth)
  }

  const handleNextClick = () => {
    const [newYear, newMonth] = month === 12 ? [year + 1, 1] : [year, month + 1]
    onChange(newYear, newMonth)
  }

  return (
    <Box
      display="flex"
      width="350px"
      height="30px"
      padding="0 12px"
      marginLeft={30}
      justifyContent="space-between"
      alignItems="center"
      borderRadius="30px"
      border="2px solid lightGray"
    >
      <IconButton onClick={handlePrevClick}>
        <ArrowBack style={{ color: 'grey' }} data-testid="date-back" />
      </IconButton>
      <RangeText />
      <IconButton onClick={handleNextClick}>
        <ArrowForward style={{ color: 'grey' }} data-testid="date-forward" />
      </IconButton>
    </Box>
  )
}

export default DateRangePicker
